import { getEntityLink } from "../../Services/helpers";

class Actions {
    actionsTaken;
    navigateTo;

    constructor(navigateTo) {
        this.actionsTaken = JSON.parse(window.localStorage.getItem('assistant:actionsTaken') || '[]');
        this.navigateTo = navigateTo;
    }

    handleActions = (conversation, performActions) => {
        conversation.entries
            .filter(entry => entry.frontendActions)
            .map(entry => entry.frontendActions)
            .flat()
            .map(action => this.doAction(action, performActions));
    }

    doAction = (action, performActions) => {
        if (this.hasTakenAction(action.idempotenceId)) {
            return;
        }

        this.recordActionTaken(action.idempotenceId);

        if (performActions) {
            if (action.redirectToPath) {
                console.log('Redirecting to', action.redirectToPath);
                this.navigateTo(action.redirectToPath);
            }

            if (action.redirectToEntity) {
                console.log('Redirecting to entity', action.redirectToEntity);
                this.navigateTo(getEntityLink(action.redirectToEntity.model, action.redirectToEntity.id));
            }
        } else {
            console.log('Skipping action', action.idempotenceId);
        }
    }

    hasTakenAction = (idempotenceId) => {
        return this.actionsTaken.indexOf(idempotenceId) > -1;
    }

    recordActionTaken = (idempotenceId) => {
        this.actionsTaken.push(idempotenceId);
        this.actionsTaken = this.actionsTaken.slice(-20);
        window.localStorage.setItem('assistant:actionsTaken', JSON.stringify(this.actionsTaken));
    }
}

export default Actions;
